import { IRailingGeometry, IStairConfig, IStepGeometry } from '@stair-craft/common/util';

import { RISER_BOARD_THICKNESS } from '../../constants';
import { railingVolume } from '../shared-railing-wood/railing-wood';
import { IStairWoodEstimate, stairWoodEstimate } from '../shared-stair-wood/stair-wood';
import { ISpiralLayout, POLE_RADIUS } from '../spiral-calculate-layout/calculate-layout';

/**
 * Spiral-specific material volumes: sector treads, risers, the solid central pole
 * (cylinder volume) and the helical railing. Differs from the shared two-stringer
 * `calculateMaterialVolume` — see `../shared-calculate-material-volume`. The pole carries the
 * steps the way stringers do, so it is weighed and priced by the stringer species.
 */
export function calculateMaterialVolume(
    steps: IStepGeometry[],
    stepCount: number,
    riserHeight: number,
    layout: ISpiralLayout,
    railings: IRailingGeometry[],
    config: IStairConfig
): IStairWoodEstimate {
    // Treads (sector-shaped)
    let treadVolume: number = 0;
    for (const step of steps) {
        const avgDepth: number = ((step.innerDepth ?? 0) + (step.outerDepth ?? step.treadDepth)) / 2;
        treadVolume += (step.treadWidth / 1000) * (avgDepth / 1000) * (step.treadThickness / 1000);
    }

    // Risers
    const riserBoardHeight: number = riserHeight - config.treadThickness;
    const riserVolume: number = stepCount * (layout.treadWidth / 1000) * (riserBoardHeight / 1000) * (RISER_BOARD_THICKNESS / 1000);

    // Central pole (cylinder)
    const poleHeight: number = (config.floorHeight + config.floorThickness) / 1000;
    const poleR: number = POLE_RADIUS / 1000;
    const poleVolume: number = Math.PI * poleR * poleR * poleHeight;

    return stairWoodEstimate(
        { tread: treadVolume, riser: riserVolume, stringer: poleVolume, railing: railingVolume(railings, config.railing) },
        config
    );
}
